import { render, staticRenderFns } from "./ReviewTicketsOld.vue?vue&type=template&id=2664a1b0&scoped=true"
import script from "./ReviewTicketsOld.vue?vue&type=script&lang=js"
export * from "./ReviewTicketsOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664a1b0",
  null
  
)

export default component.exports